import React, { useState } from "react";
import { connect } from "react-redux";

import { createBrand, checkBrandExists } from "../../../actions/Inventory/brandAction";
import { Form, Input, Drawer, Button, Col, Row, message, Modal } from "antd";
import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const Create = ({ createBrand, checkBrandExists, setUpdatelist }) => {
  const [visible, setVisible] = useState(false);
  const [color, setColor] = useState(null);
  const [form] = Form.useForm();
  const [pendingValues, setPendingValues] = useState(null);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    form.resetFields();
    setPendingValues(null);
  };

  const handleCreateBrand = (values, force = false) => {
    createBrand(values, force).then((res) => {
      setUpdatelist(false);
      message.success(values.name + " Has been added to your Brand list");
      setVisible(false);
      form.resetFields();
      setPendingValues(null);
    }).catch((error) => {
      message.error("Failed to create brand");
    });
  };

  const showDuplicateConfirm = (existingBrands, values) => {
    Modal.confirm({
      title: "Similar Brand Already Exists",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p>A similar brand name already exists:</p>
          <ul>
            {existingBrands.map((brand) => (
              <li key={brand.id}>
                <strong>{brand.name}</strong> (Slug: {brand.slug})
              </li>
            ))}
          </ul>
          <p>Do you want to create this brand anyway?</p>
        </div>
      ),
      okText: "Create Anyway",
      cancelText: "Cancel",
      onOk: () => {
        handleCreateBrand(values, true);
      },
      onCancel: () => {
        setPendingValues(null);
      },
    });
  };

  const onFinish = async (values) => {
    try {
      // Check if similar brand exists
      const response = await checkBrandExists(values.name);
      
      if (response && response.exists && response.brands.length > 0) {
        // Show confirmation modal
        setPendingValues(values);
        showDuplicateConfirm(response.brands, values);
      } else {
        // No duplicate, proceed with creation
        handleCreateBrand(values, false);
      }
    } catch (error) {
      console.error("Error checking brand:", error);
      // If check fails, proceed with creation
      handleCreateBrand(values, false);
    }
  };

  return (
    <>
      <>
        <Button
          type="primary"
          onClick={showDrawer}
          style={{ marginBottom: "10px", float: "right" }}
        >
          <PlusOutlined /> New Brand
        </Button>
        <Drawer
          title="Create a new Brand"
          width={400}
          onClose={onClose}
          visible={visible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form
            form={form}
            layout="vertical"
            hideRequiredMark
            onFinish={onFinish}
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    { required: true, message: "Please enter Brand name" },
                  ]}
                >
                  <Input placeholder="Please enter Brand name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="slug"
                  label="Slug"
                  rules={[
                    {
                      required: false,
                      message: "Please enter slug",
                    },
                  ]}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="Please enter slug"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button onClick={onClose} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
      </>
    </>
  );
};

export default connect(null, { createBrand, checkBrandExists })(Create);